<h1 class="text-center text-primary">Import</h1>
<br/>

<div class="jumbotron">
    <p class="lead">Upload your orders, this way you can save a lot of time.</p>
    It is important that your <b>Excel</b> file has the following formatting:<br/>
    <ul>
        <li>Column A: Article Number</li>
        <li>Column B: Quantity</li>
        <li>Column C: Brand (Ignored when brand is selected.)</li>
    </ul>

    <hr class="my-4">
    <div class="form-group">
        <div class="row">
            <div class="col-2">
                <label for="brand">Brand</label>
        
        
            </div>
            <div class="col-4">
                <ng-select [items]="brands " [searchable]=false [clearable]=false 
                    [formControl]="importForm.controls['brand']">
                    <ng-template ng-option-tmp let-item="item">
                        {{item}}
                    </ng-template>
                </ng-select>       
        
            </div>
        </div>
        
    </div>
    <p class="lead">      
        <input type="file" #fileInput class="browse-btn" (change)="readFile($event)" name="myfile" accept=".xlsx">
        <br/><br/>
        <button type="button" class="btn btn-primary btn-lg" (click)="upload()" [disabled]="!enableUpload">Upload</button>
      

    </p>
  </div>
